
import { defineComponent, ref, watchEffect } from "vue";
import { ErrorMessage, Field } from "vee-validate";
import { useStore } from "vuex";
import DropDownSection from "@/components/sections/DropDownSections.vue";

interface IStep2 {
  q2_1: string;
  q2_2: string;
  q2_3: string;
  q2_4: string;
  q2_5: string;
  q2_6: string;
  q2_7: string;
  q2_8: string;
  q2_9: string;
  q2_10: string;
  q2_11: string;
  q2_12: string;
  q2_13: string;
  q2_14: string;
  q2_populationOther: string;
}

export default defineComponent({
  name: "step-2",
  components: {
    Field,
    DropDownSection,
  },
  setup() {
    const store = useStore();
    const listDropDownSections = [
         {title: "Information", descriptions: [{description:
          " Some Information" }
        ]},
         
    ];
    const step2 = ref<IStep2>({
      q2_1: "0",
      q2_2: "0",
      q2_3: "0",
      q2_4: "0",
      q2_5: "0",
      q2_6: "0",
      q2_7: "0",
      q2_8: "0",
      q2_9: "0",
      q2_10: "0",
      q2_11: "0",
      q2_12: "0",
      q2_13: "0",
      q2_14: "0",
      q2_populationOther: "0",
    });

    const submitButtonRef = ref<null | HTMLButtonElement>(null);

    const submit = () => {
      if (!submitButtonRef.value) {
        return;
      }
    };

    watchEffect(() => {
      const data = store.getters.currentSubject;
      if (data === null || data.data === undefined) return;
      step2.value.q2_1 = data.data.population  && data.data.population.length>1
        && data.data.population[1].isChecked
         ? "1" : "0";
      step2.value.q2_2 = data.data.population  && data.data.population.length>2
        && data.data.population[2].isChecked
         ? "1" : "0";
      step2.value.q2_3 = data.data.population  && data.data.population.length>3
        && data.data.population[3].isChecked
         ? "1" : "0";
      step2.value.q2_4 = data.data.population  && data.data.population.length>4
        && data.data.population[4].isChecked
         ? "1" : "0";
      step2.value.q2_5 = data.data.population  && data.data.population.length>5
        && data.data.population[5].isChecked
         ? "1" : "0";
      step2.value.q2_6 = data.data.population  && data.data.population.length>6
        && data.data.population[6].isChecked
         ? "1" : "0";
      step2.value.q2_7 = data.data.population  && data.data.population.length>7
        && data.data.population[7].isChecked
         ? "1" : "0";
      step2.value.q2_8 = data.data.population  && data.data.population.length>8
        && data.data.population[9].isChecked
         ? "1" : "0";
      step2.value.q2_9 = data.data.population  && data.data.population.length>9
        && data.data.population[9].isChecked
         ? "1" : "0";
      step2.value.q2_10 = data.data.population  && data.data.population.length>10
        && data.data.population[10].isChecked
         ? "1" : "0";
         step2.value.q2_11 = data.data.population  && data.data.population.length>11
        && data.data.population[11].isChecked
         ? "1" : "0";
      step2.value.q2_12 = data.data.population  && data.data.population.length>12
        && data.data.population[12].isChecked
         ? "1" : "0";
      step2.value.q2_13 = data.data.population  && data.data.population.length>13
        && data.data.population[13].isChecked
         ? "1" : "0";
      step2.value.q2_populationOther = data.data != null
         ? data.data.populationOther : "";
    });

    return {
      submit,
      submitButtonRef,
      step2,
      listDropDownSections,
    };
  },
});
